export default "__VITE_ASSET__BL69FtaM__"